import { DealerFeatures, Feature } from 'types/Feature'
import { User } from 'types/Session'

export const accessibleFeatures = (session: User, tier: string, response: DealerFeatures) => {
  const now = new Date()

  const publishedFeatures = response.features.filter(f => f.publishedAt)
  const publishedFeatureCodes = publishedFeatures.map(feature => feature.name)

  const dealerFeatureCodes = response.dealerBetaFeatures ?? []
  const currentRole = session.isDealerAdmin ? 'dealer_admin' : session.currentRole

  const getCodes = (features: Feature[]) =>
    features.map(feature => feature.name)

  const premiumFeatureCodes = getCodes(
    publishedFeatures.filter(f =>
      f.type === 'premium' &&
      f.accessibleByRoles.includes(currentRole)
    )
  )

  if (session.isAdmin) {
    return {
      activeFeatureCodes: Array.from(new Set([
        ...getCodes(
          publishedFeatures.filter(f =>
            f.accessibleByRoles.includes('admin')
          )
        ),
        ...dealerFeatureCodes
      ])),
      premiumFeatureCodes,
      publishedFeatureCodes
    }
  }

  if (session.isFsr) {
    return {
      activeFeatureCodes: getCodes(
        publishedFeatures.filter(f =>
          f.accessibleByRoles.includes('fsr')
        )
      ),
      premiumFeatureCodes,
      publishedFeatureCodes
    }
  }

  if (tier === 'premium') {
    return {
      activeFeatureCodes: Array.from(new Set([
        ...getCodes(
          publishedFeatures.filter(f =>
            f.accessibleByRoles.includes(currentRole)
          )
        ),
        ...dealerFeatureCodes
      ])),
      premiumFeatureCodes,
      publishedFeatureCodes
    }
  }

  // Standard account → beta & free trial only
  if (tier === 'standard') {
    return {
      activeFeatureCodes: Array.from(new Set([
        ...getCodes(
          publishedFeatures.filter(f =>
            (session.isDealer || session.isTechnician) &&
            f.type === 'premium' &&
            f.accessibleByRoles.includes(currentRole) &&
            f.freeTrial &&
            (!f.freeTrialEndDate || new Date(f.freeTrialEndDate) >= now)
          )
        ),
        ...getCodes(
          publishedFeatures.filter(f =>
            f.type === 'beta' &&
            f.accessibleByRoles.includes(currentRole)
          )
        ),
        ...dealerFeatureCodes
      ])),
      premiumFeatureCodes,
      publishedFeatureCodes
    }
  }

  return { activeFeatureCodes: [], premiumFeatureCodes, publishedFeatureCodes }
}
